import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { CurriculoComponent } from 'src/components/curriculo/curriculo.component';
import { MyAccountCompanyComponent } from 'src/components/my-account-company/my-account-company.component';
import { ProfessionalExperiencesComponent } from 'src/components/professional-experiences/professional-experiences.component';
import { ProfileComponent } from 'src/components/profile/profile.component';
import { SchoolingComponent } from 'src/components/schooling/schooling.component';
import { SharedProcessListComponent } from 'src/components/shared-process-list/shared-process-list.component';
import { UserProcessListComponent } from 'src/components/user-process-list/user-process-list.component';
import { WelcomeComponent } from 'src/components/welcome/welcome.component';
import { AuthGuard } from 'src/guards/auth.guard';
// import { PreLoginGuardGuard } from 'src/guards/pre-login-guard.guard';
import { SignatureStatusGuard } from 'src/guards/signature-status.guard';
import { CustomerPanelComponent } from 'src/views/customer-panel/customer-panel.component';

const routes: Routes = [
  {
    path: 'customer', component: CustomerPanelComponent,
    canActivate: [AuthGuard],
    canActivateChild: [AuthGuard, SignatureStatusGuard],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'user-process-list' },
      { path: 'profile', component: ProfileComponent },
      { path: 'experiences', component: ProfessionalExperiencesComponent },
      { path: 'schooling', component: SchoolingComponent },
      { path: 'user-process-list', component: UserProcessListComponent },
      { path: 'my-account', component: MyAccountCompanyComponent/*, canActivate: [ SignatureStatusGuard ]*/ },
      { path: 'welcome', component: WelcomeComponent },
      { path: 'curriculo', component: CurriculoComponent }
    ]
  },
  { path: 'shared-process/:id', component: SharedProcessListComponent }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class CustomerRoutingModule { }
